import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { PageLayout } from 'shared/ui'
import { ModalFullScreen } from 'shared/ui/ModalFullScreen/ModalFullScreen'
import { MenuAIAutomation } from 'widgets/Menu/ui/MenuAIAutomation/ui/MenuAIAutomation'
import { MenuAIAutomationLayoutStore } from 'widgets/Menu/ui/MenuAIAutomation/store/menuAIAutomationLayoutStore'
import {
  MenuAIAutomationLayoutContext,
  useMenuAIAutomationLayoutContext,
} from 'widgets/Menu/ui/MenuAIAutomation/context/menuAIAutomationLayoutContext'

const MenuAIAutomationLayoutContent = observer(() => {
  const menuLayoutStore = useMenuAIAutomationLayoutContext()
  const { pageLayoutStore } = menuLayoutStore
  const rightContent = (
    <>
      <ModalFullScreen
        collapseButton={{
          iconProps: pageLayoutStore.titleIconProps,
          tooltipProps: pageLayoutStore.headerMenuTooltipIconProps,
          onClick: pageLayoutStore.headerMenuIconAction,
        }}
      />
      <Outlet />
    </>
  )

  return (
    <PageLayout
      leftContent={<MenuAIAutomation />}
      store={menuLayoutStore.pageLayoutStore}
      rightContent={rightContent}
    />
  )
})

export const MenuAIAutomationLayout = observer(() => {
  const [menuLayoutStore] = useState(() => new MenuAIAutomationLayoutStore())

  return (
    <MenuAIAutomationLayoutContext.Provider value={menuLayoutStore}>
      <MenuAIAutomationLayoutContent />
    </MenuAIAutomationLayoutContext.Provider>
  )
})
